import cep from "./cep";
import cnpj from "./cnpj";
import cpf from "./cpf";
import docs from "./docs";
import email from "./email";
import phone from "./phone";

export default {
  cep,
  cnpj,
  cpf,
  docs,
  email,
  phone,
};
